// export enum RegulatorStatus {
//     ClosedNotApplicable = 1,
//     ClosedInformationOnly = 2,
//     ClosedImplemented = 3,
//     ClosedExistingProject = 4,
//     ClosedPrudentialRegulation = 5,
//     ClosedGroupLed = 6,
//     ClosedLedElseWhere = 7,
//     ClosedApplicableButNoImpact = 8,
//     ClosedApplicableActionTaken = 46,
//     ClosedWaitingforFinalRules = 47
// }
// export const RegulatorStatusLabel = new Map<number, string>([
//     [RegulatorStatus.ClosedNotApplicable, 'Closed - Not Applicable'],
//     [RegulatorStatus.ClosedInformationOnly, 'Closed - Information Only'],
//     [RegulatorStatus.ClosedImplemented, 'Closed - Implemented'],
//     [RegulatorStatus.ClosedExistingProject, 'Closed - Existing Project'],
//     [RegulatorStatus.ClosedPrudentialRegulation, 'Closed – Prudential Regulation'],
//     [RegulatorStatus.ClosedGroupLed, 'Closed – Group Led'],
//     [RegulatorStatus.ClosedLedElseWhere, 'Closed – Led Else Where'],
//     [RegulatorStatus.ClosedApplicableButNoImpact, 'Closed – Applicable But No Impact'],
//     [RegulatorStatus.ClosedApplicableActionTaken, 'Closed - Applicable, Action Taken'],
//     [RegulatorStatus.ClosedWaitingforFinalRules, 'Closed - Waiting for Final Rules'],
// ]);

export enum LibraryType {
  Unknown = 0,
  Static = 1,
  Dynamic = 2
}
